import React, { FC } from 'react';
import { Form } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { Input } from '../../../system/components/Input';

interface Props {
  form: WrappedFormUtils;
  required?: boolean;
}

export const InputPatientInsuranceGroupNumber: FC<Props> = ({ form, required = false }): JSX.Element => (
  <Form.Item label="Insurance Group Number">
    {form.getFieldDecorator('insuranceGroupNumber', {
      rules: [{ required: required, message: "Please enter patient's insurance group number." }],
    })(<Input allowClear />)}
  </Form.Item>
);
